import { useEffect, useState } from "react";
import { Monitor } from "lucide-react";
import { Switch } from "@/components/ui/switch";
import {
  isPreviewEnv,
  getPreviewDesktopOverride,
  setPreviewDesktopOverride,
  PREVIEW_DESKTOP_EVENT,
} from "@/lib/pwa";

// Switch di SVILUPPO: simula la modalità "Orbit Desktop" SOLO in ambiente Preview.
// Non esiste in produzione (isPreviewEnv() false → il componente non renderizza nulla).
export function PreviewDesktopToggle() {
  const preview = isPreviewEnv();
  const [on, setOn] = useState(() => getPreviewDesktopOverride());

  useEffect(() => {
    const refresh = () => setOn(getPreviewDesktopOverride());
    window.addEventListener(PREVIEW_DESKTOP_EVENT, refresh);
    return () => window.removeEventListener(PREVIEW_DESKTOP_EVENT, refresh);
  }, []);

  if (!preview) return null;

  return (
    <div
      data-testid="preview-desktop-toggle"
      className="mb-4 inline-flex items-center gap-2 rounded-lg border border-dashed border-slate-300 bg-white/70 px-3 py-1.5 text-xs text-slate-500"
    >
      <Monitor className="h-3.5 w-3.5 text-slate-400" strokeWidth={2} />
      <span className="font-medium">Modalità Desktop</span>
      <Switch
        data-testid="preview-desktop-switch"
        checked={on}
        onCheckedChange={(v) => {
          setPreviewDesktopOverride(v);
          setOn(v);
        }}
        className="scale-90"
      />
      <span className="text-[10px] uppercase tracking-wide text-slate-400">solo preview</span>
    </div>
  );
}

export default PreviewDesktopToggle;
